import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from "../utils/utils";

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {

  transform(seconds: number): string {
    return Utils.secondsToTime(seconds);
  }

}
